import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({}))

export default styles
